/**
 * Lista de deseos de AMA.
 *
 * 🔴 POR QUE SIN LOGIN. Damian pregunto «para que querria iniciar sesion la
 *    gente?». La respuesta honesta es: hoy, para nada — la cuenta de Shopify
 *    solo sirve para ver pedidos anteriores, y hay UN pedido en la tienda. Una
 *    lista que EXIGE crear cuenta antes de guardar el primer corazon pierde a
 *    casi todas: cobra el costo antes de dar el beneficio. Esta guarda en el
 *    navegador y funciona al primer clic, sin cuenta.
 *
 * 🔴 Y LA CAPTURA DE MAIL VA ADENTRO DEL PANEL, no en un popup de salida. El
 *    sitio YA tiene un popup (el del 10%): un segundo popup al intentar irse
 *    convierte la visita en una pelea. En el panel, el ofrecimiento aparece
 *    cuando la clienta ya guardo algo — o sea, cuando le importa.
 *
 * 🔴 El corazon se INYECTA por JS y no se edita `card-product.liquid`. Ese
 *    snippet tiene 35 KB y lo usa toda la tienda: un error ahi rompe la grilla,
 *    la home y los recomendados de una sola vez. Asi se saca quitando una linea
 *    del layout.
 *
 * Limite conocido, dicho de frente: al guardarse en el navegador, la lista NO
 * viaja entre dispositivos. Por eso el ofrecimiento de mandarsela por mail.
 */
(function () {
  var LLAVE = 'ama_deseos_v1';
  var ESPACIOS = new RegExp('[ ' + String.fromCharCode(10, 9) + ']+', 'g');

  function leer() {
    try { return JSON.parse(localStorage.getItem(LLAVE) || '[]'); } catch (e) { return []; }
  }
  function guardar(lista) {
    try { localStorage.setItem(LLAVE, JSON.stringify(lista)); } catch (e) {}
    pintarContador();
  }
  function esta(url) { return leer().some(function (x) { return x.url === url; }); }

  function datos(tarjeta) {
    var a = tarjeta.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var img = tarjeta.querySelector('img');
    var t = tarjeta.querySelector('.card__heading, .card-information__text, h3, h2');
    var pr = tarjeta.querySelector('.price-item--sale, .price-item--regular, .price__container .price-item');
    return {
      url: a.getAttribute('href').split('?')[0],
      titulo: (t ? t.textContent : a.textContent).trim().slice(0, 80),
      precio: pr ? pr.textContent.trim().replace(ESPACIOS, ' ') : '',
      foto: img ? (img.currentSrc || img.src || '') : ''
    };
  }

  function svgCorazon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 20.7l-1.1-1C6 15.4 3 12.7 3 9.3 3 6.6 5.1 4.5 7.8 4.5c1.5 0 3 .7 3.9 1.9.9-1.2 2.4-1.9 3.9-1.9 2.7 0 4.8 2.1 4.8 4.8 0 3.4-3 6.1-7.9 10.4l-1.1 1z"/></svg>';
  }

  function ponerCorazon(tarjeta) {
    if (tarjeta.querySelector('.ama-deseo')) return;
    var d = datos(tarjeta);
    if (!d) return;
    // 🔴 EL CORAZON VA EN LA TARJETA ENTERA, NO EN `.card__media`. Dawn pone un
    //    enlace que cubre TODA la tarjeta (`.full-unstyled-link`), y vive en
    //    `.card__content`, que es hermano posterior de `.card__media`: por orden
    //    de pintado le gana al corazon aunque el corazon tenga z-index. Lo
    //    detecto la prueba de clic — el corazon se veia perfecto y al tocarlo
    //    se iba al producto. Colgado del contenedor externo y agregado ULTIMO,
    //    queda por encima.
    var medios = tarjeta;
    if (getComputedStyle(medios).position === 'static') medios.style.position = 'relative';
    var b = document.createElement('button');
    b.type = 'button';
    var on = esta(d.url);
    b.className = 'ama-deseo' + (on ? ' ama-deseo--on' : '');
    b.setAttribute('aria-label', on ? 'Quitar de mi lista' : 'Guardar en mi lista');
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.innerHTML = svgCorazon();
    b.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); alternar(d, b); });
    medios.appendChild(b);
  }

  function reflejar(url, on, menos) {
    document.querySelectorAll('.ama-deseo').forEach(function (x) {
      if (x === menos) return;
      var t = x.closest('.card-wrapper, .grid__item, .card');
      var dd = t && datos(t);
      if (dd && dd.url === url) {
        x.classList.toggle('ama-deseo--on', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
        x.setAttribute('aria-label', on ? 'Quitar de mi lista' : 'Guardar en mi lista');
      }
    });
  }

  function alternar(d, boton) {
    var lista = leer();
    var i = lista.findIndex(function (x) { return x.url === d.url; });
    var on = i < 0;
    if (i >= 0) lista.splice(i, 1); else lista.unshift(d);
    guardar(lista);
    if (boton) {
      boton.classList.toggle('ama-deseo--on', on);
      boton.setAttribute('aria-pressed', on ? 'true' : 'false');
      boton.setAttribute('aria-label', on ? 'Quitar de mi lista' : 'Guardar en mi lista');
    }
    // el mismo producto puede aparecer en varias tarjetas de la misma pagina
    reflejar(d.url, on, boton);
    pintarPanel();
  }

  function pintarContador() {
    var n = leer().length;
    var b = document.querySelector('.ama-deseos-abrir');
    if (!b) return;
    b.classList.toggle('ama-deseos-abrir--con', n > 0);
    var c = b.querySelector('.ama-deseos-n');
    if (c) c.textContent = n > 0 ? String(n) : '';
    b.setAttribute('aria-label', n > 0 ? 'Mi lista, ' + n + ' guardados' : 'Mi lista');
  }

  function ponerBotonEncabezado() {
    if (document.querySelector('.ama-deseos-abrir')) return;
    var carrito = document.querySelector('#cart-icon-bubble, a[href="/cart"], .header__icon--cart');
    if (!carrito) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ama-deseos-abrir header__icon';
    b.innerHTML = svgCorazon() + '<span class="ama-deseos-n"></span>';
    carrito.parentNode.insertBefore(b, carrito);
    b.addEventListener('click', function () { abrirPanel(true); });
    pintarContador();
  }

  function panel() { return document.querySelector('.ama-deseos'); }

  function abrirPanel(si) {
    var p = panel(); if (!p) return;
    if (si) pintarPanel();
    p.classList.toggle('ama-deseos--abierto', si);
    document.body.classList.toggle('ama-deseos-bloqueo', si);
    if (si) { var c = p.querySelector('.ama-deseos__cerrar'); if (c) c.focus(); }
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function pintarPanel() {
    var p = panel(); if (!p) return;
    var cuerpo = p.querySelector('.ama-deseos__cuerpo');
    var pie = p.querySelector('.ama-deseos__guardar');
    var lista = leer();
    if (!lista.length) {
      cuerpo.innerHTML = '<p class="ama-deseos__vacio">Todavía no guardaste nada.<br>' +
        'Tocá el corazón de cualquier producto para tenerlo a mano.</p>';
      if (pie) pie.hidden = true;
      return;
    }
    if (pie) pie.hidden = false;
    cuerpo.innerHTML = lista.map(function (x) {
      return '<div class="ama-deseo-item">' +
        (x.foto ? '<a href="' + esc(x.url) + '"><img src="' + esc(x.foto) + '" alt="" loading="lazy"></a>' : '') +
        '<div class="ama-deseo-item__tx">' +
        '<a class="ama-deseo-item__t" href="' + esc(x.url) + '">' + esc(x.titulo) + '</a>' +
        '<span class="ama-deseo-item__p">' + esc(x.precio) + '</span></div>' +
        '<button type="button" class="ama-deseo-item__x" data-url="' + esc(x.url) + '" aria-label="Quitar de mi lista">&times;</button>' +
        '</div>';
    }).join('');
    cuerpo.querySelectorAll('.ama-deseo-item__x').forEach(function (b) {
      b.addEventListener('click', function () {
        var u = b.getAttribute('data-url');
        guardar(leer().filter(function (x) { return x.url !== u; }));
        reflejar(u, false, null);
        pintarPanel();
      });
    });
  }

  function barrer() {
    // 🔴 UN SELECTOR SOLO, NO UNA LISTA. `.card-wrapper` y `.card` estan
    //    ANIDADOS: con la lista, cada producto recibia DOS corazones —16 para 8
    //    tarjetas— y quedaban apilados uno sobre otro. Se ve identico en
    //    pantalla y rompe el clic. Lo encontro la prueba, no la vista.
    var tarjetas = document.querySelectorAll('.card-wrapper');
    if (!tarjetas.length) tarjetas = document.querySelectorAll('.card');
    tarjetas.forEach(function (t) {
      if (t.closest('.ama-deseos')) return;
      ponerCorazon(t);
    });
  }

  function iniciar() {
    ponerBotonEncabezado();
    barrer();
    pintarContador();
    var p = panel();
    if (p) {
      p.querySelector('.ama-deseos__cerrar').addEventListener('click', function () { abrirPanel(false); });
      p.querySelector('.ama-deseos__fondo').addEventListener('click', function () { abrirPanel(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') abrirPanel(false); });
    }
    // 🔴 La grilla se repinta al filtrar y al paginar. Sin esto los corazones
    //    desaparecen despues de filtrar y parece que la lista se borro.
    var mo = new MutationObserver(function () { barrer(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
